module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Snapping"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "scroller",
    staticStyle: {
      "padding-top": "44px"
    },
    attrs: {
      "snapping": _vm.snapping,
      "snap-height": _vm.snapHeight,
      "animationDuration": _vm.animationDuration
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372bb2ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Snapping.vue
// module id = 43
// module chunks = 0